import { DatasetShareDto } from '.';
import { DatasetFileTypeOption } from '../enums/dataset-file-type-option.enum';
import { TrainingMethod } from '../types/training-method.type';
import { FileConversionStatus } from './file-conversion-status.model';
import { FileModel } from './file-model.model';

export interface DatasetDtoGet {
    datasetId: string;
    name: string;
    email: string;
    statistics: DatasetStatisticsDtoGet;
    userId: string;
    createdAt: Date;
    datasetShares: DatasetShareDto[];
    trainingType?: TrainingMethod;
}

export class DatasetDtoPost {
    constructor(
        public name: string,
        public trainingType?: TrainingMethod,
    ) {
        this.name = name;
        this.trainingType = trainingType;
    }
}

export class Dataset {
    constructor(
        public datasetId: string,
        public name: string,
        public email: string,
        public statistics: DatasetStatistics,
        public userId: string,
        public createdAt: Date,
        public datasetShares: DatasetShareDto[],
        public trainingType?: TrainingMethod,
        public userFullName?: string,
    ) {}

    static createInstance(obj: {
        datasetId: string;
        name: string;
        email: string;
        statistics: { classes: string[]; numberOfFiles: number; numberOfAnnotationFiles: number; numberOfCziFiles: number; numberOfInvalidFiles: number };
        userId: string;
        createdAt: Date;
        datasetShares: DatasetShareDto[];
        trainingType?: TrainingMethod;
        userFullName?: string;
    }): Dataset {
        return new Dataset(
            obj.datasetId,
            obj.name,
            obj.email,
            DatasetStatistics.createInstance(obj.statistics),
            obj.userId,
            obj.createdAt,
            obj.datasetShares,
            obj.trainingType,
            obj.userFullName,
        );
    }
}

export class DatasetStatistics {
    constructor(
        public classes: string[],
        public numberOfFiles: number,
        public numberOfAnnotationFiles: number,
        public numberOfCziFiles: number,
        public numberOfInvalidFiles: number,
    ) {}

    static createInstance(obj: DatasetStatisticsDtoGet): DatasetStatistics {
        return new DatasetStatistics(obj.classes, obj.numberOfFiles, obj.numberOfAnnotationFiles, obj.numberOfCziFiles, obj.numberOfInvalidFiles);
    }
}

export interface DatasetStatisticsDtoGet {
    classes: string[];
    numberOfFiles: number;
    numberOfAnnotationFiles: number;
    numberOfCziFiles: number;
    numberOfInvalidFiles: number;
}

export interface DatasetDtoPatch extends DatasetDtoPost {
    datasetId: string;
}

export interface DatasetFilePayload {
    fileName: string;
    datasetId: string;
}

export interface DatasetFileResponse {
    userId: string;
    sasToken: string;
    sasReadToken: string;
    sasTokenUri: string;
    blobFileName: string;
    datasetId: string;
    fileId: string;
    fullpath: string;
    createdAt: string;
}

/**
 * Fetching a dataset retrieves annotations and images in the following structure.
 */
export interface DatasetFiles {
    files: FileModel[];
    annotations: FileModel[];
    filesConversions: FileConversionStatus[];
}

export interface DatasetFolder {
    name: string;
    folderType: DatasetFileTypeOption;

    /**
     * Name of the JSON property which comes from backend
     */
    jsonPropName: string;
}
